/* istanbul ignore file */
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts'
import { useTheme } from 'styled-components'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnsAndExchangesPieChart = ({ data }) => {
  const theme = useTheme()
  const renderCustomLabel = ({ cx, cy, midAngle, outerRadius, Icon }) => {
    const RADIAN = Math.PI / 180
    const radius = (outerRadius + 60) / 2

    const iconX = cx + radius * Math.cos(-midAngle * RADIAN)
    const iconY = cy + radius * Math.sin(-midAngle * RADIAN)

    return (
      <>
        <foreignObject x={iconX - 10} y={iconY - 10} width={36} height={36}>
          <Icon size={24} />
        </foreignObject>
      </>
    )
  }

  return (
    <Styles.ChartContainer>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            startAngle={180}
            endAngle={0}
            innerRadius={60}
            outerRadius={150}
            dataKey="value"
            label={renderCustomLabel}
            labelLine={false}
          >
            <Cell fill={theme.colors.danger.onSurface} />
            <Cell fill={theme.colors.ai.onSurface} />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <Styles.ValuesContainer>
        <div>
          <Text type="titleL">
            <FormatNumber style="percent">{data[0].value}</FormatNumber>
          </Text>
          <Text type="bodyMRegular">
            {data[0]?.count} {data[0].name}
          </Text>
        </div>
        <div>
          <Text type="titleL">
            <FormatNumber style="percent">{data[1].value}</FormatNumber>
          </Text>
          <Text type="bodyMRegular">
            {data[1]?.count} {data[1].name}
          </Text>
        </div>
      </Styles.ValuesContainer>
    </Styles.ChartContainer>
  )
}

export default ReturnsAndExchangesPieChart
